import { render, staticRenderFns } from "./document2.vue?vue&type=template&id=75dfb733&"
import script from "./document2.vue?vue&type=script&lang=ts&"
export * from "./document2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports